/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllFacilityServiceAreasResponse } from './FindAllFacilityServiceAreasResponse';
import {
    FindAllFacilityServiceAreasResponseFromJSON,
    FindAllFacilityServiceAreasResponseFromJSONTyped,
    FindAllFacilityServiceAreasResponseToJSON,
} from './FindAllFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface FindAllFacilityServiceAreas200Response
 */
export interface FindAllFacilityServiceAreas200Response {
    /**
     * 
     * @type {FindAllFacilityServiceAreasResponse}
     * @memberof FindAllFacilityServiceAreas200Response
     */
    data?: FindAllFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the FindAllFacilityServiceAreas200Response interface.
 */
export function instanceOfFindAllFacilityServiceAreas200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllFacilityServiceAreas200ResponseFromJSON(json: any): FindAllFacilityServiceAreas200Response {
    return FindAllFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function FindAllFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityServiceAreas200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function FindAllFacilityServiceAreas200ResponseToJSON(value?: FindAllFacilityServiceAreas200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllFacilityServiceAreasResponseToJSON(value.data),
    };
}

